function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { FC, Ref, Fragment, ElementType, CSSProperties } from 'react';
import cn from 'classnames';
import { Link, ILinkProps } from '../Link';
require("./Copyright.css");
var styles = {
  "Root": "Copyright-module-Root_15u"
};
export const Copyright = ({
  className,
  controlRef,
  innerRef,
  linkText,
  style = {},
  tag = 'div',
  to,
  yearFrom,
  ...props
}) => {
  const Component = tag;
  const currentYear = new Date().getFullYear();
  const ContentComponent = to ? Link : Fragment;
  const contentProps = to ? {
    href: to,
    variant: 'black'
  } : {};
  return /*#__PURE__*/React.createElement(Component, _extends({
    style: style,
    className: cn(styles.Root, className),
    ref: innerRef || controlRef
  }, props), /*#__PURE__*/React.createElement(ContentComponent, contentProps, '© ', Boolean(yearFrom) && `${yearFrom} – `, currentYear, " ", linkText));
};
if (process.env.NODE_ENV !== 'production') {
  Copyright.displayName = 'Copyright';
}